module.exports = __webpack_public_path__ + "img/4-d-squoll-participant-satisfaction-md.ef12332f.png";